import { alpha } from "@material-ui/core";
import { Box, Paper, Typography } from "@material-ui/core";

import styled from 'styled-components'
import PhysicsWorld from "../../../logic/loop/PhysicsWorld";
import Player from "../../../logic/physics/Player";
import MGLoader from "../../../logic/saves/MGLoader";
import { shape, theme } from "../../../theme";
import GameGlobals from "../GameGlobals";
import GamePage from "../GamePage";

const Key = styled.div`
	padding: 2px 8px;
	border-radius: ${shape.borderRadius};
	
	background: ${alpha(theme.palette.primary.main, 0.25)};
	color: ${theme.palette.primary.main};
	border-bottom: 2px solid ${alpha(theme.palette.primary.main, 0.5)};
`

const Plus = styled.div`
	color: ${theme.palette.primary.main};
`

const Description = styled.div`
	display: flex;
	align-items: baseline;
	gap: 8px;
`

const ItemTitle = styled(Typography)`
	font-weight: bold;
	margin-bottom: 8px;
`

const InfoBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`

const InfoContainer = styled.div`
	background: ${alpha(theme.palette.primary.main, 0.10)};
	padding: 8px;
	border-radius: ${shape.borderRadius};
`

export default function ElementsPage() {
	return (
		<GamePage
			side={(
				<Paper elevation={0} style={{ marginRight: 16, overflow: 'hidden' }}>
					<Box p="1rem" overflow="hidden auto" display="flex" flexDirection="column" gridGap="40px" height="100%">
						<Typography variant="h3">Controls</Typography>
						<InfoContainer>
							<ItemTitle>🔍 Zoom</ItemTitle>
							<Description>
								Scroll <Key>Mouse Wheel</Key> to zoom
							</Description>
						</InfoContainer>
						<InfoContainer>
							<ItemTitle>🤚 Pan</ItemTitle>
							<Description>
								Drag <Key>Middle Click</Key> to pan
							</Description>
						</InfoContainer>
						<InfoContainer>
							<ItemTitle>📃 Select node to add</ItemTitle>
							<InfoBlock>
								<Description>
									Open node list from the top right of the mana graph
								</Description>
								<Description>
									or press either <Key>Ctrl</Key><Plus>+</Plus><Key>E</Key> or <Key>Ctrl</Key><Plus>+</Plus><Key>P</Key>
								</Description>
								<Description>
									Selected node to add can be seen at the bottom right of the mana graph
								</Description>
							</InfoBlock>
						</InfoContainer>
						<InfoContainer>
							<ItemTitle>➕ Add Node</ItemTitle>
							<Description>
								Press <Key>Shift</Key><Plus>+</Plus><Key>Left Click</Key> to add a node
							</Description>
						</InfoContainer>
						<InfoContainer>
							<ItemTitle>➕ Add connection</ItemTitle>
							<Description>
								Press and drag <Key>Alt</Key><Plus>+</Plus><Key>Left Click</Key> from one node to another
							</Description>
						</InfoContainer>
						<InfoContainer>
							<ItemTitle>🧬 Modify node</ItemTitle>
							<InfoBlock>
								<Description>
									<Key>Double Click</Key> a node to start editing the node
								</Description>
								<Description>
									While editing, you can drag the node to move it around
								</Description>
								<Description>
									While dragging, hold <Key>Ctrl</Key> to snap to grid
								</Description>
								<Description>
									hold <Key>Ctrl</Key><Plus>+</Plus><Key>Shift</Key> to snap to a smaller grid
								</Description>
								<Description>
									And in some cases scroll over the node, to amplify / mutate it
								</Description>
								<Description>
									Node tooltip will have further information regarding how to mutate the node
								</Description>
								<Description>
									<Key>Click</Key> away from a node to exit editing
								</Description>
							</InfoBlock>
						</InfoContainer>
						<InfoContainer>
							<ItemTitle>❌ Delete node / connection</ItemTitle>
							<Description>
								Press <Key>Middle Click</Key> on node / connection arrow
							</Description>
						</InfoContainer>
					</Box>
				</Paper>
			)}
			onLoaded={(world: PhysicsWorld) => {
				const player = new Player({
					world,

					x: 150,
					y: 150
				})

				MGLoader.loadCasterFromFile('Controls.mg.json', player).then(() => {
					GameGlobals.setSelectedEntity(player)
				})

				world.add(player)

			}}
		/>
	)
}
